$(document).ready(function() {

  if ($(".sortable-participants").length) {

    $("#participants-accordion").sortable({
      cursor: 'pointer',
      placeholder: 'placeholder',
      update: function(event, ui) {
        var data = $(this).sortable('serialize');
        //alert($(this).attr("data-sortable")+"?"+data);
        $.get($(this).attr("data-sortable") + "?" + data);
      }

    }).disableSelection();

  }

});
